import React, { ReactNode, useEffect, useState } from 'react'

import { Skeleton } from 'antd'

import getHraBenefitOverview, { HraBenefitOverviewResponse } from 'core/application/benefit/getHraBenefitOverview'
import AllowanceType from 'core/domain/benefit/allowanceType'

import { queryRequest } from 'common/RequestUtils'

import MonthlyAllowance from '../../../common/benefitAllowance/MonthlyAllowance'
import YearlyAllowance from '../../../common/benefitAllowance/YearlyAllowance'

interface AllowanceSummaryProps {
  planPeriodId: string
  allowanceType: AllowanceType
}

const AllowanceSummary: React.FC<AllowanceSummaryProps> = ({ planPeriodId, allowanceType }) => {
  const [allowanceSummary, setAllowanceSummary] = useState<HraBenefitOverviewResponse>()
  const [gettingAllowanceSummary, setGettingAllowanceSummary] = useState<boolean>(false)

  useEffect(() => {
    getAllowanceSummary()
  }, [planPeriodId])

  const getAllowanceSummary = async () => {
    setGettingAllowanceSummary(true)
    const allowancesReport = await queryRequest(() => getHraBenefitOverview(planPeriodId))
    setAllowanceSummary(allowancesReport)
    setGettingAllowanceSummary(false)
  }

  const getAllowanceSummaryBasedOnType = (): ReactNode => {
    if (allowanceType === AllowanceType.Monthly) {
      return (
        <MonthlyAllowance
          reimbursementsDue={allowanceSummary?.reimbursementsDue}
          totalReimbursed={allowanceSummary?.totalReimbursed}
          totalAllowanceRemaining={allowanceSummary?.totalAllowanceRemaining}
          totalAllowance={allowanceSummary?.totalAllowance}
        />
      )
    } else {
      return (
        <YearlyAllowance
          reimbursementsDue={allowanceSummary?.reimbursementsDue}
          totalReimbursed={allowanceSummary?.totalReimbursed}
          totalAllowanceRemaining={allowanceSummary?.totalAllowanceRemaining}
          totalAllowance={allowanceSummary?.totalAllowance}
        />
      )
    }
  }

  return (
    <Skeleton active loading={gettingAllowanceSummary}>
      {getAllowanceSummaryBasedOnType()}
    </Skeleton>
  )
}

export default AllowanceSummary
